// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2_icv","signatureBlock":"Footer_signatureBlock__3A3b-","signature":"Footer_signature__1Nxeb"};